import { valkTalkPermissions } from '../../entities/ValkTalkPost/ValkTalkPostHelpers'
import trans from '../../helpers/trans'
import { ValkTalkRoutes } from '../helpers'
import { SubNavRoute } from '../routes'

export type ValkTalkNavigationRouteKey = 'valkTalkPosts'

export const valkTalkNavigationRoutes: SubNavRoute[] = [
    {
        key: 'valkTalkPosts',
        path: ValkTalkRoutes.posts(),
        label: trans('routes.valkTalk.posts.label'),
        permissions: valkTalkPermissions,
        hasSomePermission: true,
    },
]
